import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { OtpForm } from '@/components';
import { COMMON_CONTAINER_ID, navigationPages } from '@/config';
import { UserPreferenceEnum } from '@/api';
import { ToastContainer } from 'react-toastify';

import amlbotLogo from '@/assets/images/logo-amlbot.svg';

import styles from './TraceSignUp.module.sass';

const TraceSignUp: FC = () => {
  const handleSuccess = (token: string) => {
    window.location.href = navigationPages.TRACE_INVESTIGATIONS.path;
  };

  return (
    <>
      <Helmet>
        <title>AMLBot - AI Trace Signup</title>
        <meta
          name="description"
          content="AMLBot AI Trace Investigation signup"
        />
      </Helmet>

      <div className={styles.page}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <img src={amlbotLogo} alt="AMLBot" className={styles.logo} />
            <h1 className={styles.title}>
              Start Investigating with AI-Powered Trace
            </h1>
            <p className={styles.description}>
              Unlock advanced blockchain trace investigations powered by AI.
              Sign up to get started.
            </p>
          </div>

          <OtpForm
            preference={UserPreferenceEnum.AI_TRACE}
            stepTitles={{
              1: 'Create your account to access AI Trace',
              2: 'Enter the OTP code we sent to your email to continue',
            }}
            onSuccess={handleSuccess}
          />
        </div>
      </div>

      <ToastContainer
        containerId={COMMON_CONTAINER_ID}
        position="top-center"
        limit={3}
        enableMultiContainer
        hideProgressBar
      />
    </>
  );
};

export default TraceSignUp;
